import { useQuery } from '@apollo/client'
import { Select, SelectProps } from 'antd'
import React from 'react'
import { GESTIONNAIRE_QUERY } from '../../apollo/query/personne.query'
import { Personne } from '../../types'

const GestionnaireFormInput = (props: SelectProps<any>) => {
  const { data, loading } = useQuery<{ gestionnaires: Personne[] }>(GESTIONNAIRE_QUERY)
  if (loading) return null
  const { gestionnaires } = data ?? {}
  return (
    <Select
      optionFilterProp="label"
      showSearch
      placeholder="Selectionnez un gestionnaire"
      options={gestionnaires?.map((gestionnaire) => ({
        label: `${gestionnaire.prenom} ${gestionnaire.nom}`,
        value: gestionnaire.id,
      }))}
      {...props}
    />
  )
}

export default GestionnaireFormInput
